var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动名称", prop: "activityTitle" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "text",
                          clearable: "",
                          placeholder: "请输入活动名称",
                          disabled: _vm.isDetail
                        },
                        model: {
                          value: _vm.childData.activityTitle,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "activityTitle", $$v)
                          },
                          expression: "childData.activityTitle"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "价格区间", prop: "priceRange" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "text",
                          clearable: "",
                          placeholder: "请输入价格区间",
                          disabled: _vm.isDetail
                        },
                        model: {
                          value: _vm.childData.priceRange,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "priceRange", $$v)
                          },
                          expression: "childData.priceRange"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动场地", prop: "activityLocation" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "text",
                          clearable: "",
                          placeholder: "请输入活动场地",
                          disabled: _vm.isDetail
                        },
                        model: {
                          value: _vm.childData.activityLocation,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "activityLocation", $$v)
                          },
                          expression: "childData.activityLocation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "actiOrder" } },
                    [
                      _c("el-input-number", {
                        staticClass: "form-item-number",
                        attrs: { disabled: _vm.isDetail, min: 1, max: 99 },
                        model: {
                          value: _vm.childData.actiOrder,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "actiOrder", $$v)
                          },
                          expression: "childData.actiOrder"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          !_vm.isBuildParty && !_vm.isDashboard
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "报名时间",
                            prop: "registrationDates"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              disabled: _vm.isDetail,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "报名开始时间",
                              "end-placeholder": "报名结束时间"
                            },
                            on: { change: _vm.handleRegistrationDate },
                            model: {
                              value: _vm.childData.registrationDates,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.childData,
                                  "registrationDates",
                                  $$v
                                )
                              },
                              expression: "childData.registrationDates"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间", prop: "activeDates" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              disabled: _vm.isDetail,
                              "value-format": "yyyy-MM-dd",
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "活动开始时间",
                              "end-placeholder": "活动结束时间"
                            },
                            on: { change: _vm.handleActiveDates },
                            model: {
                              value: _vm.childData.activeDates,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "activeDates", $$v)
                              },
                              expression: "childData.activeDates"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { staticClass: "required", attrs: { label: "活动内容" } },
            [
              _c("Tinymce", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isDetail,
                    expression: "!isDetail"
                  }
                ],
                ref: "editor",
                attrs: { menubar: !_vm.isDetail, height: 300 },
                model: {
                  value: _vm.childData.activityOption,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "activityOption", $$v)
                  },
                  expression: "childData.activityOption"
                }
              }),
              _c("Tinymce", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isDetail,
                    expression: "isDetail"
                  }
                ],
                ref: "viewer",
                staticStyle: { width: "580px" },
                attrs: {
                  height: 300,
                  menubar: false,
                  toolbar: _vm.toolbar,
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.childData.activityOption,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "activityOption", $$v)
                  },
                  expression: "childData.activityOption"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "报名须知", prop: "remark" } },
            [
              _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: {
                  autosize: { minRows: 2, maxRows: 6 },
                  maxlength: "300",
                  "show-word-limit": "",
                  type: "textarea",
                  clearable: "",
                  placeholder: "请输入报名须知",
                  disabled: _vm.isDetail
                },
                model: {
                  value: _vm.childData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "remark", $$v)
                  },
                  expression: "childData.remark"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动封面", prop: "files" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    "on-exceed": _vm.handleExceed,
                    name: "files",
                    limit: 1,
                    "on-error": _vm.handleError,
                    "on-success": _vm.handleSuccess,
                    action: _vm.uploadUrl,
                    "on-preview": _vm.handlePreview,
                    "on-remove": _vm.handleRemove,
                    "before-remove": _vm.beforeRemove,
                    "before-upload": _vm.beforeUpload,
                    multiple: "",
                    disabled: _vm.isDetail,
                    "file-list": _vm.files
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        disabled: _vm.isDetail
                      }
                    },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisible,
                    width: "700px",
                    title: "预览"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          !_vm.isDetail
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
                [_vm._v(_vm._s(_vm.$t("button.confirm")))]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }